<template>
  <div style="padding-top: 40px">
    <div>
      <p class="navadno-besedilo">
        DMZ je kratica za demilitarizirano cono (DeMilitarized Zone). DMZ je posebno krajevno omrežje, ki je
        ločeno od našega krajevnega omrežja in od interneta. Modem bo tako posredoval IP-pakete iz WAN-a,
        ki ne pripadajo nobeni od aplikacij v gostiteljski računalnik DMZ.
      </p>
    </div>
    <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
      Naprava ni priklopljena v omrežje.
      Prosimo, preverite ustreznost priklopa naprave ali nas pokličite na 064 064 064.
    </div>
    <div style="padding-top: 20px">
      <p class="navadno-besedilo">
        Izberite želen IP naslov in kliknite »Spremeni«, da aktivirate gostitelja DMZ. <br>
        Za deaktivacijo izberite polje "Brez DMZ".
      </p>
    </div>
    <div style="padding-top: 25px">
      <b>
        <span class="dmz-label">
          DMZ je vklopljen na IP naslovu:
        </span>
        <el-select v-model="izbranIp"  placeholder="..." v-loading="nalaganjeIpjev"
                   class="velikost-izbirnika-dmz">
          <el-option v-for="(ip, index) in mozniIpji"
                     :value="ip"
                     :label="index"
                     :key="index"/>
        </el-select>
      </b>
    </div>
    <div style="padding-top: 20px">
      <el-button @click="PosodobiDmzConfig" class="gumb-potrdi">
        SPREMENI
      </el-button>
    </div>
    <div style="padding-top: 10px">
      <InfoKomponentaMreznaOprema/>
    </div>
  </div>
</template>
<script>
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {Button, Option, Select, Collapse, CollapseItem} from 'element-ui'
import InfoKomponentaMreznaOprema from './InfoKomponentaMreznaOprema'

export default {
  name: 'dmz',
  props: {
    idIzbranaOprema: {},
    povezanoVOmrezje: false
  },
  emits: ['successNotification'],
  data () {
    return {
      title: 'DMZ',
      clientAgent: null,
      mozniIpji: {},
      nalaganjeIpjev: false,
      izbranIp: '',
      dmzIpString: ''
    }
  },
  components: {
    InfoKomponentaMreznaOprema,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetDmzConfig()
  },
  methods: {
    GetDmzConfig () {
      if (typeof this.idIzbranaOprema !== 'undefined' && this.povezanoVOmrezje) {
        this.nalaganjeIpjev = true
        let param = ['idOprema=' + this.idIzbranaOprema]
        this.clientAgent.postWsRequest(
          this,
          'tr069/dmz/info',
          param,
          null,
          'SetDmzInfo',
          'ErrDmzInfo')
      }
    },
    SetDmzInfo (podatki) {
      this.izbranIp = podatki.data.DMZHost
      this.mozniIpji = podatki.options
      this.dmzIpString = this.mozniIpji[this.izbranIp] !== '' ? this.mozniIpji[this.izbranIp] : '/'
      this.nalaganjeIpjev = false
    },
    ErrDmzInfo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    PosodobiDmzConfig () {
      if (typeof this.idIzbranaOprema !== 'undefined') {
        let param = ['idOprema=' + this.idIzbranaOprema]
        param.push('ip=' + this.izbranIp)
        this.clientAgent.postWsRequest(
          this,
          'tr069/dmz/configure',
          param,
          this.izbranIp,
          'SetDmzConfig',
          'ErrDmzConfig')
      }
    },
    SetDmzConfig () {
      this.$emit('successNotification')
    },
    ErrDmzConfig (podatki) {
      this.GetDmzConfig()
      this.ShowWarningMessage(podatki)
    }
  },
  watch: {
    idIzbranaOprema: function () {
      if (this.idIzbranaOprema !== null) {
        this.GetDmzConfig()
      }
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/dmz.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/Dmz.vue